import { Component } from '@angular/core';

@Component({
	selector: 'app-paywall-cta',
	templateUrl: './paywall-cta.component.html',
	styleUrls: ['./paywall-cta.component.scss'],
})
export class PaywallCtaComponent {}
